import { ShoutoutsCol, Sidepanel } from 'components';
import { useSelector } from 'react-redux';

const ShoutoutsPage = ({ visible, setVisible, user, data, onDelete }) => {
  const { isMobile } = useSelector((state) => state.appState);

  return (
    <Sidepanel visible={visible} closeModal={() => setVisible(false)} isMobile={isMobile} wid={617}>
      <ShoutoutsCol user={user} data={data} closeModal={() => setVisible(false)} onDelete={onDelete} />
    </Sidepanel>
  );
};

export default ShoutoutsPage;
